import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import TaskManagement from './TaskManagement';
import TaskDetails from '../pages/TaskDetails';

const TasksContainer = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const handleCloseTaskDetails = () => {
    // Navigate back to tasks list
    navigate('/dashboard/tasks', { replace: true });
  };

  // Check if we're on the task details route
  const isTaskDetailsRoute = location.pathname.includes('/task/') && location.pathname.includes('/details');

  // If we're on task details route and have an ID, show TaskDetails
  if (isTaskDetailsRoute && id) {
    return (
      <TaskDetails
        taskId={id}
        onClose={handleCloseTaskDetails}
      />
    );
  }

  // Otherwise, show TaskManagement
  return <TaskManagement />;
};

export default TasksContainer;
